import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row q-gutter-sm q-my-sm" }

import { NavActivity } from '../types/navigation'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useTimers } from '../store/timers'
import { Timer } from '../types/timers'
import FormHeader from './FormHeader.vue'
import FormTravel from './FormTravel.vue'
import FormParentActivity from './FormParentActivity.vue'
import { useI18n } from 'vue-i18n'
import { useGetOdometerReading } from '../composables/getOdometerReading'


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalForms',
  props: {
    modalType: {},
    insertData: { default: undefined }
  },
  emits: ["toggleDrawer", "closeModal", "toggleTravelActive"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
//translations
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)

const { getActiveParentTimer, getAllParentTimers } = storeToRefs(useTimers())

//start odometer default for new
const defaultStartOdo = computed(() => useGetOdometerReading().previous.value)

const activeType = (type: Timer['type']) => {
  return getActiveParentTimer.value?.type === type
}

//emits
const toggleNav = () => {
  emit('toggleDrawer')
}
const toggleTravelActive = () => {
  emit('toggleTravelActive')
}
const closeModal = () => {
  emit('closeModal')
}

//template logic
const activeButDifferentTimerType = computed(
  () =>
    getActiveParentTimer.value &&
    !activeType(props.modalType.type) &&
    typeof props.insertData === 'undefined'
)
const typeIsTravel = computed(() => props.modalType.type === 'travel')
const typeIsNotStore = computed(() => props.modalType.type !== 'store')
const typeIsStore = computed(() => props.modalType.type === 'store')
//form values
const isInsert = computed(() => typeof props.insertData !== 'undefined')
const insertTimes = computed(() => {
  if (isInsert.value) {
    return { start: props.insertData!.start_time, end: props.insertData!.end_time }
  } else {
    return undefined
  }
})
//Form travel values
const isInsertTravel = computed(() => isInsert.value || incompleteTravel.value)
const incompleteTravel = computed(() => {
  return getAllParentTimers.value.length > 0
    ? getAllParentTimers.value[getAllParentTimers.value.length - 1].data.incomplete
    : false
})
const travelIndex = computed(() => {
  return incompleteTravel.value ? getAllParentTimers.value.length - 1 : undefined
})
const insertTimesTravel = computed(() => {
  return incompleteTravel.value
    ? {
        start: getAllParentTimers.value[getAllParentTimers.value.length - 1].start_time,
        end: getAllParentTimers.value[getAllParentTimers.value.length - 1].end_time
          ? getAllParentTimers.value[getAllParentTimers.value.length - 1].end_time
          : new Date(),
      }
    : insertTimes.value
})

const insertOdo = computed(() => {
  return incompleteTravel.value
    ? {
        startOdo: getAllParentTimers.value[getAllParentTimers.value.length - 1].data.odometer_start,
        endOdo: getAllParentTimers.value[getAllParentTimers.value.length - 1].data.odometer_end,
      }
    : {
        startOdo: isInsert.value ? props.insertData!.data.odometer_start : defaultStartOdo.value,
        endOdo: isInsert.value ? props.insertData!.data.odometer_end : undefined,
      }
})
const locations = computed(() => {
  return incompleteTravel.value
    ? {
        departing: getAllParentTimers.value[getAllParentTimers.value.length - 1].data.departing,
        departingStoreName:
          getAllParentTimers.value[getAllParentTimers.value.length - 1].data.departingStoreName,
        departingStoreNumber:
          getAllParentTimers.value[getAllParentTimers.value.length - 1].data.departingStoreNumber,
        destination: getAllParentTimers.value[getAllParentTimers.value.length - 1].data.destination,
        destinationStoreName:
          getAllParentTimers.value[getAllParentTimers.value.length - 1].data.destinationStoreName,
        destinationStoreNumber:
          getAllParentTimers.value[getAllParentTimers.value.length - 1].data.destinationStoreNumber,
      }
    : props.insertData?.data
})

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, {
    style: {"min-width":"280px"},
    class: "q-pa-md"
  }, {
    default: _withCtx(() => [
      _createVNode(FormHeader, { type: _ctx.modalType }, null, 8, ["type"]),
      (activeButDifferentTimerType.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('form.endCurrentMessage')), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_q_card_actions, {
              align: "right",
              class: "text-primary"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: label('close')
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ], 64))
        : (typeIsTravel.value)
          ? (_openBlock(), _createBlock(FormTravel, {
              key: 1,
              index: travelIndex.value,
              insert: isInsertTravel.value,
              "insert-times": insertTimesTravel.value,
              "insert-odo": insertOdo.value,
              locations: locations.value,
              onSaved: _cache[0] || (_cache[0] = ($event: any) => (toggleTravelActive(), closeModal(), toggleNav())),
              onStarted: _cache[1] || (_cache[1] = ($event: any) => (toggleTravelActive())),
              onCancel: _cache[2] || (_cache[2] = ($event: any) => (closeModal())),
              onClose: _cache[3] || (_cache[3] = ($event: any) => (closeModal(), toggleNav()))
            }, null, 8, ["index", "insert", "insert-times", "insert-odo", "locations"]))
          : (typeIsNotStore.value)
            ? (_openBlock(), _createBlock(FormParentActivity, {
                key: 2,
                index: activeType(_ctx.modalType.type) ? _unref(getAllParentTimers).length - 1 : undefined,
                insert: isInsert.value,
                "insert-times": insertTimes.value,
                "end-state": typeof _ctx.insertData !== 'undefined' ? true : activeType(_ctx.modalType.type),
                "activity-type": _ctx.modalType.type,
                onCancel: _cache[4] || (_cache[4] = ($event: any) => (closeModal(), toggleNav())),
                onStarted: _cache[5] || (_cache[5] = ($event: any) => (closeModal(), toggleNav())),
                onClose: _cache[6] || (_cache[6] = ($event: any) => (closeModal(), toggleNav()))
              }, null, 8, ["index", "insert", "insert-times", "end-state", "activity-type"]))
            : (typeIsStore.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createTextVNode(_toDisplayString(label('promptStoreVisit')), 1)
                ], 64))
              : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})